import type { CSSProperties } from "react";
import { backgroundColors, cssClass } from "./constant";

export type FillBlanksStylesType = {
  outerDiv: CSSProperties;
  imageContainer: CSSProperties;
  image: CSSProperties;
  textContainer: CSSProperties;
  blankNumber: CSSProperties;
  blocksContainer: CSSProperties;
  blockContainer: CSSProperties;
  optionContainer: CSSProperties;
  textBlankCircle: CSSProperties;
  questionFontSize: number;
  optionFontSize: number;
};

export function getFillBlanksStyles(canvasHeight: number): FillBlanksStylesType {
  return {
    outerDiv: {
      ...cssClass.outerDiv,
      ...cssClass.fontFamily,
      gap: canvasHeight * 0.02,
    },

    imageContainer: {
      position: "relative",
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      width: canvasHeight * 0.1,
      height: canvasHeight * 0.1,
      verticalAlign: "middle",
      backgroundColor: "#F1F5F9",
      borderRadius: "0.5rem",

      overflow: "hidden",
    },

    image: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },

    textContainer: {
      padding: canvasHeight * 0.01,
      borderRadius: "12px",

      backgroundColor: backgroundColors.white,
      // A stored "\n" must render as a real line break, not collapse into a space — CSS's default
      // white-space: normal collapses newlines like any other whitespace. `whiteSpace` is inherited,
      // so this alone also covers the text-segment <span>s inside (see FillBlanksRenderer's
      // renderTextWithBlanks) without needing to repeat it there. convertToRN strips this key for
      // mobile, where RN's <Text> already renders "\n" as a line break with no CSS involved.
      whiteSpace: "pre-wrap",
    },

    textBlankCircle: {
      width: canvasHeight * 0.02,
      height: canvasHeight * 0.02,
      display: "inline-block",
      backgroundColor: "#3B82F6",
      borderRadius: "9999px",
      textAlign: "center",
      color: "#FFFFFF",
      fontSize: "0.75rem",
    },

    blankNumber: {
      width: canvasHeight * 0.025,
      height: canvasHeight * 0.025,
      fontSize: "0.75rem",
      textAlign: "center",
      color: "#FFFFFF",
      backgroundColor: "#3B82F6",
      borderRadius: "100%",
      aspectRatio: 1,
      justifyContent: "center",
      alignItems: "center",
    },

    blocksContainer: {
      display: "flex",
      flexDirection: "column",
      gap: canvasHeight * 0.02,
    },

    blockContainer: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: canvasHeight * 0.012,
    },

    optionContainer: {
      position: "relative",
      padding: canvasHeight * 0.008,
      // outline: "2px solid transparent",
      ...cssClass.centerFlex,
      ...cssClass.button,
    },

    questionFontSize: (canvasHeight || 600) * 0.022,
    optionFontSize: (canvasHeight || 600) * 0.022,
  };
}
